/*
 * API_STATUS := OK | ERROR
 * RESPONSE_STATUS := OK | BAD_FORMAT
 *
 * {
 *      "clients":[
 *          {
 *              "contactId":"60cb3c52-564e-44f5-a4f8-4d96e13572b0",
 *              "name":"Doe, John",
 *              "address":"1/15 Jarrah Drive",
 *              "clientReferenceNumber":"12345ABC",
 *              "phone":"0412377404"
 *          },
 *      ],
 *      "hasMore":true
 *  }
 *
 */
Core.PortalCheckoutClientSearch = function(rootElem) {
    if (rootElem == null) {
        return;
    }

    /*

        DATASET

     */

    function hasDataset(elem, name) {
        return elem &&
               elem.dataset &&
               typeof elem.dataset[name] !== 'undefined';
    }

    function warnData(msg) {
        console.warn(msg);
    }

    function getDataset(elem, name) {
        return hasDataset(elem, name)
                ? elem.dataset[name]
                : warnData('Data attribute for ' + name + ' missing');
    }


    /*

        UTILS

     */

    function HandleSessionExpired(callback) {
        $.get('/account/IsSessionExpired', function(response) {
            if (response == true) {
                window.location.href = '/logout';
            }
            else if (callback) {
                callback();
            }
        });
    }


    /*


        HTML TMPL


     */

    function tableWrapTmpl(content, label) {
        return '<div class="portal-checkout__client-detail--list-wrap">' +
               '<div id="clientDetailListTable" class="portal-checkout__client-detail--list-table">' +
                    '<div class="pccdlt-row pccdlt-head">' +
                        '<div class="pccdlt-col"></div> '+
                        '<div class="pccdlt-col">' + label + '</div>' +
                        '<div class="pccdlt-col">Client Name</div>' +
                        '<div class="pccdlt-col">Phone</div>' +
                        '<div class="pccdlt-col">Address</div>' +
                    '</div>' +

                    content +
                '</div>' +
                '</div>';
    }

    function pagination(content) {
        return `<div class="pccdlt-row pccdlt-body position-relative" style="height: 50px;" data-pagination >
                    <div class="pccdlt-col position-absolute w-100 text-center">
                        ${content}
                    </div>
                    <div class="pccdlt-mobile pccdlt-col pccdlt-col__show-mobile  position-absolute w-100 text-center">
                        ${content}
                    </div>
                </div>`;
    }

    function youReachedTheEndOfTheList() {
        return pagination('<span class="small text-grey-lightest">You reached the end of the list</span>');
    }

    function showMoreResults(pageNum) {
        return pagination('<button class="btn-link" data-page="' + pageNum + '" data-btn-show-more>Show more results</button>');
    }

    function rowTmpl(client) {
        return `<div class="pccdlt-row pccdlt-body ${data.contactId === client.contactId ? 'selected' : ''}" data-contact-id="${client.contactId}" data-row-page="${client.page}" >
                <div class="pccdlt-col pccdlt-col__show-mobile pccdlt-acts">
                    <div class="pccdlt-select">
                        <span class="pccdlt-select__icon icon-approved"></span>
                    </div>
                </div>

                <div class="pccdlt-col" title="${client.clientReferenceNumber}">
                    <div class="pccdlt-refno">${client.clientReferenceNumber}</div>
                </div>
                <div class="pccdlt-col">
                    <div class="pccdlt-name">${client.name}</div>
                </div>
                <div class="pccdlt-col">${client.phone}</div>
                <div class="pccdlt-col">${client.address}</div>

                <div class="pccdlt-mobile pccdlt-col pccdlt-col__show-mobile">
                    <p class="pccdlt-mobile__row">
                        <strong>${client.clientReferenceNumberLabel || "Client Ref #"}:</strong> ${client.clientReferenceNumber}
                    </p>
                    <p class="pccdlt-mobile__row">
                        <strong>Client Name:</strong> ${client.name}
                    </p>
                    <p class="pccdlt-mobile__row">
                        <strong>Phone Number:</strong> ${client.phone}
                    </p>
                    <p class="pccdlt-mobile__row">
                        <strong>Address:</strong> ${client.address}
                    </p>
                </div>
            </div>`;
    }

    function getTableBody(clientList, hasMore, nextPage) {
        function genFnNextPage(nextPage) {
            return function(client) {
                client['page'] = nextPage - 1;
                return client;
            }
        }

        var clientListHtml = clientList
                                .map(genFnNextPage(nextPage))
                                .map(rowTmpl)
                                .join('');
        var footer = hasMore
            ? showMoreResults(nextPage)
            : youReachedTheEndOfTheList();

        return clientListHtml + footer;
    }

    function apiErrorTmpl() {
        return '<div class="p-3 text-center small"> Sorry, an error occurred during the search. <br/> Try Later</div>';
    }

    function noResultsTable() {
        return '<div class="p-3 text-center small" colspan="4"> No results available</div>';
    }

    function resultsTable(clients, hasMore) {
        var content = getTableBody(clients, hasMore, 2);
        var label = clients[0].clientReferenceNumberLabel || "Client Ref #";
        return tableWrapTmpl(content, label);
    }



    var el = {
        root: rootElem,
        input: rootElem.querySelector('[data-input]') || warnData('Please add [data-input] attribute'),
        btn: rootElem.querySelector('[data-btn]'|| warnData('Please add [data-btn] attribute')),
        results: rootElem.querySelector('[data-results]')|| warnData('Please add [data-results] attribute'),
    };

    var data = {
        searchApi: getDataset(el.root, 'searchApi'),
        selectApi: getDataset(el.root, 'selectApi'),
        contactId: '',
        pageNum: 0,
    };

    var m = {
        init: function() {
            function isNull(item) {
                return item == null;
            }

            function checkAllValid(previousValue, currentValue) {
                return previousValue && !isNull(currentValue);
            }

            function isAllValid() {
                return [data.searchApi, data.selectApi, el.input, el.btn, el.results].reduce(checkAllValid, true);
            }

            if (!isAllValid()) {
                return;
            }

            m.boot();
        },

        boot: function() {
            m.searchListeners();
        },

        // -- STR -- Search Client -----------------------
        searchListeners: function() {
            el.btn.addEventListener('click', m.doSearchClient)
            el.input.addEventListener('keydown', function(e) {
                (e.key === "Enter") && m.doSearchClient()
            });
        },

        doSearchClient: function() {
            function onFail(data) {
                m.showSearchApiError();
            }

            function onSuccess(data) {
                m.updateResults(data);
                m.onSelectClient(1);
                m.onShowMore();
            }

            function onDone() {
                Core.HidePageLoading();
                m.showResults();
            }

            Core.ShowPageLoading();

            var payload = { Keywords: el.input.value };

            $.post(data.searchApi, payload, onSuccess)
             .fail(onFail)
             .always(onDone);
        },

        showResults: function() {
            document.location.host.indexOf('localhost') === -1
                ? HandleSessionExpired(function() {
                    $(el.results).slideDown();
                  })
                : $(el.results).slideDown();
        },

        showSearchApiError: function() {
            el.results.innerHTML = apiErrorTmpl();
        },

        updateResults: function(data) {
            el.results.innerHTML = (data && data.clients && data.clients.length > 0)
                ? resultsTable(data.clients, data.hasMore)
                : noResultsTable();
        },
        // -- END -- Search Client -----------------------


        onShowMore: function() {
            function onClick(e) {
                var nextPage = $(e.currentTarget).data("page");
                nextPage = parseInt(nextPage);

                m.doShowMore(nextPage);
            }

            Array
                .from(el.root.querySelectorAll('[data-btn-show-more]'))
                .forEach(function(elm) {
                    elm.addEventListener('click', onClick)
                });
        },

        doShowMore: function(nextPage) {
            function onFail(data) {
                Array
                    .from(el.root.querySelectorAll('[data-pagination]'))
                    .forEach(function(elm) {
                        elm.innerHTML = pagination(apiErrorTmpl());
                    });
            }

            function onSuccess(data) {
                m.appendResults(data, nextPage);
                m.onSelectClient(nextPage);
                m.onShowMore();
            }

            function onDone() {
                Core.HidePageLoading();
            }

            Core.ShowPageLoading();

            var payload = { Keywords: el.input.value, PageNumber: nextPage };

            $.post(data.searchApi, payload, onSuccess)
             .fail(onFail)
             .always(onDone);
        },


        appendResults: function(data, nextPage) {
            var pagination = el.root.querySelector('[data-pagination]');
            var results = (data && data.clients && data.clients.length > 0)
                && getTableBody(data.clients, data.hasMore, nextPage + 1);

            pagination
                && results
                && $(pagination).replaceWith(results);
        },

        // -- STR -- Select Client -----------------------
        onSelectClient: function(page) {
            function onClick(e) {
                var contactId = $(e.currentTarget).data("contactId");

                m.doSelectClient(contactId);
            }

            Array
                .from(el.root.querySelectorAll('[data-row-page="' + page + '"]'))
                .forEach(function(elm) {
                    elm.addEventListener('click', onClick)
                });
        },

        doSelectClient: function(contactId) {
            function onFail(data) {
                m.showSearchApiError();
            }

            function onSuccess(data) {
                m.updateClientDetails(data, contactId);
            }

            function onDone() {
                Core.HidePageLoading();
            }

            Core.ShowPageLoading();

            var payload = { ContactID: contactId };

            $.post(data.selectApi, payload, onSuccess)
             .fail(onFail)
             .always(onDone);
        },

        updateClientDetails: function(data, contactId) {
            data.contactId = contactId;

            //show detail when checkbox is checked
            var cbIsChecked = function ($el) {
                var id = $el.closest('.portal-checkout__cb-control').attr('id')
                    , $target = $('div[data-toggle="' + id + '"]');
                if ($target) $target.slideDown();
            };

            var initAddressAutocomplete = function() {
              var $autocomplete = $('.addressAutocomplete');
              if ($autocomplete.length > 0) {
                Core.Engine.handleAddressAutocomplete();
              }
            };

            var clientDetails = document.querySelector('#checkOutClientDetailsReadonly');
            clientDetails
                ? $(clientDetails).html(data)
                : console.warning('#checkOutClientDetailsReadonly not present details not updated');

            $("#hidSelectedContactID").val(contactId);

            $(".pccdlt-body").removeClass('selected');
            $("[data-contact-id=" + contactId + "]").addClass('selected');

            $(".portal-checkout__client-detail--item-addnew-client input[type=checkbox], .portal-checkout__client-detail--item-addnew-client input[type=radio]").uniform();
            Core.PortalCheckoutCheckboxToggle.init();
            $('#divClientDetails select:not(.kendo-ignore,.kendo-initialized)').kendoDropDownList().addClass('kendo-initialized');

            //check checkbox
            $('#NewShippingAddress').prop('checked') && cbIsChecked($('#NewShippingAddress'));
            $('#NewContactInfo').prop('checked') && cbIsChecked($('#NewContactInfo'));

            $('#divClientDetails').slideDown();
            $('#divSearchResult').slideUp();
            $("#frmClientRefNo").find("#ContactID").val(contactId);

            initAddressAutocomplete();

            setTimeout(function () {
                Core.DVAInformation.init({
                    domActivites: "#DVAActivityOfDailyLiving",
                    domBehaviour: "#DVABehaviour",
                    domComplexHealthCare: "#DVAComplexHealthCare",
                })
            }, 500);
        },
        // -- END -- Select Client -----------------------

    };

    m.init();

    return m;
};
